export const configes = {
    domainName: "WeBuyAnyFrenchLHDCars",
    domainURL: "WeBuyanyfrenchlhhdcars.com",
    domainId: "677e10a5a287ec34fe5cff64",
  };